"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_BENEFIT_ZUORA = exports.SELECT_BENEFITS = void 0;
exports.SELECT_BENEFITS = `
	mutation selectBenefits($selectedBenefitsData: [SelectedBenefitsItems]) {
		selectBenefits(selectedBenefitsData: $selectedBenefitsData){
			product
			variant
		}
	}
`;
exports.UPDATE_BENEFIT_ZUORA = `
	mutation updateBenefitZuora($productId: String, $sku: String, $existingRatePlanName: String, $date: String, $membershipBody: String, $orderNumber: String){
        updateBenefitZuora(productId: $productId, sku: $sku, existingRatePlanName: $existingRatePlanName, date: $date, membershipBody: $membershipBody, orderNumber: $orderNumber)
	}
`;
//# sourceMappingURL=benefit-queries.js.map